import { render } from "./PaymentDetails.vue?vue&type=template&id=6c7dda4b&scoped=true&lang=pug"
import script from "./PaymentDetails.vue?vue&type=script&lang=ts"
export * from "./PaymentDetails.vue?vue&type=script&lang=ts"

import "./PaymentDetails.vue?vue&type=style&index=0&id=6c7dda4b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c7dda4b"

export default script